export * from './tage-sorter.component';
export * from './tage-sorter.component.module';
